module.exports = __webpack_public_path__ + "img/payu_new_logo.e4c064df.png";